var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 455,
    viewBox: "0 0 375 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.596 -217C312.284 -176.251 338.606 -129.069 355.06 -78.1472C371.514 -27.2255 377.777 26.4384 373.491 79.7805C369.206 133.123 354.456 185.098 330.083 232.74C305.711 280.382 272.194 322.756 231.445 357.445C190.696 392.133 143.514 418.455 92.5919 434.909C41.6702 451.363 -11.9937 457.626 -65.3358 453.341C-118.678 449.055 -170.654 434.305 -218.295 409.933C-265.937 385.56 -308.312 352.043 -343 311.294L-199.292 188.96C-180.669 210.837 -157.919 228.831 -132.342 241.916C-106.764 255.001 -78.8601 262.92 -50.2223 265.221C-21.5844 267.521 7.2262 264.159 34.5646 255.325C61.903 246.492 87.2338 232.36 109.111 213.737C130.988 195.114 148.982 172.364 162.067 146.786C175.152 121.209 183.071 93.3048 185.372 64.6669C187.672 36.0291 184.31 7.21849 175.476 -20.1199C166.643 -47.4583 152.511 -72.7891 133.888 -94.666L277.596 -217Z",
    fill: "#3162AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -53.5,
    cy: 34.5,
    r: 243.5,
    fill: "#FF2200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopcircle);
export default __webpack_public_path__ + "static/media/Topcircle.15e1efdc01c78bbaf74c2857a098eab7.svg";
export { ForwardRef as ReactComponent };